import React from 'react'

export default function PermissionDenied() {
  return (
    <>
      <section className="permission-denied-area">
        <h3>permission denied</h3>
      </section>
    </>
  )
}
